module.exports = __webpack_public_path__ + "img/xx.1863d124.jpg";